export const answers = {
    "什么是网络任务":
        "网络任务主要为资源需求方提供IP资源，用于完成压测，并发模拟、性能检测等应用，不占用上行带宽。进行网络任务需要设备提供 公网IP 资源，并确保网络较为通畅，没有严重的掉线、延迟、丢包等情况。",
    "网络任务的收益情况及奖励总额？": [
        "单个节点的收益取决于在网稳定情况及当前全网的节点总量，收益由矿池释放，矿池占 BxC 总量的 40%，分四年释放完毕。",
        "奖励总额：7,000,000,000 * 40% = 2,800,000,000 BxC",
        "奖励结算周期：UTC时间 60分钟",
        "UTC时间 每小时奖励总额为：Total（RT） = 79,908 BxC"
    ],
    "网络任务收益的收益计算方式：": [
        "某台在网设备的贡献度 P =（在线稳定贡献度Po+任务贡献度Pw）* α。",
        "设用户为 x ，拥有 n 台设备，全网共有 m 个用户，则用户 x 的账户贡献度 Px = P1+P2+P3+......+Pn，全网用户的总贡献度PT = Px1+Px2+Px3+......+Pxm",
        "所以 UTC 时间每小时内用户 x 的收益 Rx = （Px / PT）* RT *（100%-1%）（每笔交易收取1%的平台技术服务费用）",
        "其中:",
        "Po=单台设备在线分钟数*Ko，Ko为在线稳定性权重系（当前 Ko = 1）",
        "Pw=单台设备任务分钟数*Kw，Kw为任务权重系数(网络任务下 Kw = 9，计算任务会增加CPU、存储等权重）",
        "α 是由哈希计算得出，分布于 0.95-1.05 之间的挖矿因子，期望为1",
        "RT = 79,908"
    ],
    "什么是计算任务？":
        "按需和弹性的内容/存储/应用分布式架构，为资源需求方提供算力，带宽、存储等资源。",
    "计算任务的奖励总额？":
        "计算任务收益由资源使用方支付，不从矿池产出，无总量限制。",
    "计算任务的收益计算方式？":
        "单台设备计算收益=设备稳定系数（闲时/忙时） * 奖励系数 * 任务需求单价 * 流量",
    "存储任务收益": "暂未上线",
    "What is network task?": [
        "Network tasks mainly provide IP resources to the demand-side for pressure measurement, concurrent simulation, performance detection and other applications, which do not occupy uplink bandwidth. ",
        "To run the network task successfully, it is necessary for the devices to public network IP resources while ensure that the network is relatively smooth, without serious dropouts, delays, packet dropouts, etc."],
    "What is the network task’s revenue overall and total reward?": [
        "The reward per node depends on its network stability and the total number of nodes in the current network. The rewards are released out in 4 years from the pool, the BxC’s amount of which is 40% of the total.",
        "Total rewards: 7,000,000,000 * 40% = 2,800,000,000 BxC",
        "Reward settlement period: UTC time 60 minutes",
        "UTC Time The total hourly reward is: Total(RT) = 79,908 BxC"
    ],
    "Which is the network task’s reward algorithm?": [
        "Contribution  of a certain network device P = (online stability contribution Po + task contribution Pw) * α",
        "Let the user be x, who owns n devices, and there are m users in the whole network, then the account contribution of user x is Px = P1+P2+P3+...+Pn, and the total contribution of users of the whole network is PT = Px1 +Px2+Px3+...+Pxm",
        "So UTC time user x reward per hour Rx = (Px / PT) RT (100% - 1%) (1% of platform technology service fee per transaction)",
        "Among them",
        "Po=Online number of minutes for a single device*Ko, Ko is the online stability weight system (currently Ko = 1)",
        "Pw=single device task minutes*Kw, Kw is the task weight coefficient (Kw = 9 under network task, the calculation task will increase the weight of CPU, storage, etc.)",
        "α is a mining factor calculated by hash, distributed between 0.95 and 1.05, expected to be 1",
        "RT = 79,908"
    ],
    "What is computing task?":
        "Computing task refers to on-demand content/ storage/ application distributed architecture which provide computing power, bandwidth, storage and other resources to the demand-side.",
    "What is the total reward for computing task?":
        "The reward of computing task is paid by whom has used the corresponding resources, instead of the pool, without total limit.",
    "Which is the computing task’s reward algorithm?":
        "Computing task reward for single device = device stability coefficient (idle/busy) * reward coefficient * task requirement unit price * traffic",
    "Storage task reward":
        "NOT released yet"
};